function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 24.03125 47.871094 C 22.328125 47.871094 21.03125 46.570312 21.03125 44.871094 L 21.03125 3.070312 C 21.03125 1.371094 22.328125 0.0703125 24.03125 0.0703125 C 25.730469 0.0703125 27.03125 1.371094 27.03125 3.070312 L 27.03125 44.871094 C 27.03125 46.570312 25.730469 47.871094 24.03125 47.871094 Z M 24.03125 47.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 44.929688 26.972656 L 3.128906 26.972656 C 1.429688 26.972656 0.128906 25.671875 0.128906 23.972656 C 0.128906 22.269531 1.429688 20.972656 3.128906 20.972656 L 44.929688 20.972656 C 46.628906 20.972656 47.929688 22.269531 47.929688 23.972656 C 47.929688 25.671875 46.628906 26.972656 44.929688 26.972656 Z M 44.929688 26.972656 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddblack);
export default __webpack_public_path__ + "static/media/add black.3c681819e5ea3c3146e3f99ad0a3a64e.svg";
export { ForwardRef as ReactComponent };